<div class="container">
  <div class="card-body">
    <h3 
      class="card-title mb-0" 
      [style.color]="organisationID === 2 ? '#2596BE' :(organisationID === 5 ? '#ffc300' : '#972f32') ">
      {{ organisationID === 2 ? 'Društveni dokumenti' : (organisationID === 5 ? 'Oznanila' : 'Zapisniki') }}
    </h3>
    <hr>

  <div *ngIf="isAdmin" class="upload-section mb-3">
    <label for="fileInput" class="button-74">Izberi datoteko</label>
    <input id="fileInput" type="file" (change)="onFileSelected($event)" />
    
    <!-- Display the file name -->
    <span *ngIf="selectedFileName">{{ selectedFileName }}</span>

    <button (click)="uploadReport(false)" class="button-74">Naloži datoteko</button>
  </div>
  
  <div *ngIf="displayedReports.length === 0">
    <p>Na žalost ni datotek.</p>
  </div>

  <!-- Make the table scrollable -->
  <div *ngIf="displayedReports.length > 0" style="overflow-x: auto;">
    <table class="report-table">
      <thead>
        <tr>
          <th>Ime datoteke</th>
          <th>Datum</th>
          <th *ngIf="isAdmin">Možnosti</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let report of displayedReports">
          <td>
            <a [href]="report.fileUrl" target="_blank" rel="noopener noreferrer">
                {{ report.fileName }}
            </a>
          </td>  
          <td>
            {{ report.timeStamp | date: 'dd.MM.yyyy' }}
          </td>            
          <td *ngIf="isAdmin">
            <button class="delete-btn" (click)="deleteReport(report.reportID)">Izbriši</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="pagination-buttons mt-3">
    <button *ngIf="displayedReports.length < reports.length" (click)="loadMore()" class="button-74">Pokaži več</button>
    <button *ngIf="reports.length > 10 && displayedReports.length > 10" (click)="hideExtra()" class="button-74">Skrij</button>
  </div>
</div>
</div>

<div *ngIf="organisationID == 2" class="container">
  <div class="card-body">
    <h3 
      class="card-title mb-0" 
      [style.color]="'#2596BE'">
      {{ 'Rezultati tekem' }}
    </h3>
    <hr>

  <div *ngIf="isAdmin" class="upload-section mb-3">
    <label for="fileInput" class="button-74">Izberi datoteko</label>
    <input id="fileInput" type="file" (change)="onFileSelected($event)" />
    
    <!-- Display the file name -->
    <span *ngIf="selectedFileName">{{ selectedFileName }}</span>

    <button (click)="uploadReport(true)" class="button-74">Naloži datoteko</button>
  </div>
  
  <div *ngIf="displayedRaceData.length === 0">
    <p>Na žalost ni rezultatov.</p>
  </div>

  <!-- Make the table scrollable -->
  <div *ngIf="displayedRaceData.length > 0" style="overflow-x: auto;">
    <table class="report-table">
      <thead>
        <tr>
          <th>Ime datoteke</th>
          <th>Datum</th>
          <th *ngIf="isAdmin">Možnosti</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let report of displayedRaceData">
          <td>
            <a [href]="report.fileUrl" target="_blank" rel="noopener noreferrer">
                {{ report.fileName }}
            </a>
          </td>  
          <td>
            {{ report.timeStamp | date: 'dd.MM.yyyy' }}
          </td>            
          <td *ngIf="isAdmin">
            <button class="delete-btn" (click)="deleteReport(report.reportID)">Izbriši</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="pagination-buttons mt-3">
    <button *ngIf="displayedRaceData.length < reports.length" (click)="loadMore()" class="button-74">Pokaži več</button>
    <button *ngIf="reports.length > 10 && displayedRaceData.length > 10" (click)="hideExtra()" class="button-74">Skrij</button>
  </div>
</div>
</div>